import React from 'react';
import './Loader.css';
export default function Loader({hasText, isVisible}) {
    return <div className={`Loader ${isVisible ? 'Loader-visible': ''}`}>
        {hasText && <p className="Loader-text">Chargement en cours...</p>}
        <div className="Loader-ring"><div></div><div></div><div></div><div></div></div>
    </div>
}